export const SET_PURCHASE_INFO = 'SET_PURCHASE_INFO';
export const SET_STORENO_INFO = 'SET_STORENO_INFO';

export interface SetPurchaseInfoAction {
  type: typeof SET_PURCHASE_INFO;
  payload: any;
}

export interface SetStoreNoInfoAction {
  type: typeof SET_STORENO_INFO;
  payload: any;
}

export type ActionTypes = SetPurchaseInfoAction | SetStoreNoInfoAction;

export const setPurchaseInfo = (purchaseInfo: any): SetPurchaseInfoAction => ({
  type: SET_PURCHASE_INFO,
  payload: purchaseInfo,
});

export const setStoreNoInfo = (storeNoInfo: any): SetStoreNoInfoAction => ({
  type: SET_STORENO_INFO,
  payload: storeNoInfo,
});
